import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(formData.email, formData.password);
      toast.success('Erfolgreich angemeldet!');
      navigate('/');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Zugangsdaten.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] dark:bg-[#0A0A0A] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-extrabold tracking-tight text-[#09090B] dark:text-[#FAFAFA] mb-2">
            Willkommen zurück
          </h1>
          <p className="text-[#52525B] dark:text-[#A1A1AA]">
            Melden Sie sich an, um fortzufahren
          </p>
        </div>

        <div className="bg-white dark:bg-[#121212] rounded-2xl border border-black/10 dark:border-white/10 p-8" data-testid="login-form">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email">E-Mail</Label>
              <Input
                id="email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="mt-1"
                data-testid="email-input"
              />
            </div>

            <div>
              <Label htmlFor="password">Passwort</Label>
              <Input
                id="password"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                className="mt-1"
                data-testid="password-input"
              />
            </div>

            <Button
              type="submit"
              className="w-full rounded-full bg-[#0055FF] hover:bg-[#0044CC] text-white"
              disabled={loading}
              data-testid="login-submit-button"
            >
              {loading ? 'Anmelden...' : 'Anmelden'}
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-[#52525B] dark:text-[#A1A1AA]">
            Noch kein Konto?{' '}
            <Link to="/register" className="text-[#0055FF] dark:text-[#3377FF] hover:underline font-medium" data-testid="register-link">
              Registrieren
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
